<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalDeleteAssessmentTemplate } from '../../../model/assessments/modal-delete-assessment-template.hook'

defineOptions({
  name: 'ModalDeleteAssessmentTemplate',
})

const {
  refIsOpen,
  refIsLoading,
  refTemplate,
  refIsBlocked,
  refBlockedCountLabel,
  closeModal,
  confirmDelete,
  openDuplicate,
} = useModalDeleteAssessmentTemplate()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    :loading="refIsLoading"
    :title="refIsBlocked ? 'Assessment template is in use' : 'Delete assessment template'"
    is-close-button
    @click:overlay="closeModal"
    @click:close="closeModal"
  >
    <div class="modal-delete-assessment-template">
      <AppText
        v-if="!refIsBlocked"
        name="body2"
        color="slate-700"
      >
        Delete "{{ refTemplate?.title }}"? This cannot be undone.
      </AppText>

      <template v-else>
        <AppText
          name="body2"
          color="slate-700"
        >
          "{{ refTemplate?.title }}" is used by {{ refBlockedCountLabel }}, so it cannot be
          deleted.
        </AppText>
        <AppText
          name="body2"
          color="slate-700"
        >
          Duplicate it instead — the copy is independent, so revising it can never change an
          assessment that is already in progress.
        </AppText>
      </template>
    </div>

    <template #controls>
      <BtnPrimary
        v-if="!refIsBlocked"
        text="Delete"
        color="red"
        :disabled="refIsLoading"
        @click="confirmDelete"
      />
      <BtnPrimary
        v-else
        text="Duplicate"
        color="emerald"
        :disabled="refIsLoading"
        @click="openDuplicate"
      />
      <BtnSecondary
        text="Cancel"
        @click="closeModal"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDeleteAssessmentTemplate.scss" />
